import { BREAKPOINTS } from './constants'

const detectBreakpoint = (target = '', width = window.innerWidth) => {
  switch (target) {
    case 'large':
      return width >= BREAKPOINTS.large
    case 'desktop':
      return width >= BREAKPOINTS.tablet && width < BREAKPOINTS.large
    case 'tablet':
      return width >= BREAKPOINTS.mobile && width < BREAKPOINTS.tablet
    default:
      return width < BREAKPOINTS.mobile
  }
}

const detectCurrentBreakpoint = () => {
  const width = window.innerWidth

  if (width < BREAKPOINTS.mobile) {
    return 'mobile'
  } else if (width >= BREAKPOINTS.mobile && width < BREAKPOINTS.desktop) {
    return 'tablet'
  } else if (width >= BREAKPOINTS.tablet && width < BREAKPOINTS.large) {
    return 'desktop'
  } else if (width > BREAKPOINTS.large) {
    return 'large'
  }
}

export { detectBreakpoint, detectCurrentBreakpoint }
